export default function (obj, _Vdt, blocks, $callee) {
  _Vdt || (_Vdt = Vdt);
  obj || (obj = {});
  blocks || (blocks = {});
  var h = _Vdt.miss.h,
      hc = _Vdt.miss.hc,
      hu = _Vdt.miss.hu,
      widgets = this && this.widgets || {},
      _blocks = {},
      __blocks = {},
      __u = _Vdt.utils,
      extend = __u.extend,
      _e = __u.error,
      _className = __u.className,
      __o = __u.Options,
      _getModel = __o.getModel,
      _setModel = __o.setModel,
      _setCheckboxModel = __u.setCheckboxModel,
      _detectCheckboxChecked = __u.detectCheckboxChecked,
      _setSelectModel = __u.setSelectModel,
      self = this.data,
      $this = this,
      scope = obj,
      Animate = self && self.Animate,
      parent = ($callee || {})._super;

  var _self$get = self.get(),
      children = _self$get.children,
      className = _self$get.className,
      text = _self$get.text;

  return h('div', {
    'data-clipboard-text': function () {
      try {
        return [text][0];
      } catch (e) {
        _e(e);
      }
    }.call(this)
  }, function () {
    try {
      return [children][0];
    } catch (e) {
      _e(e);
    }
  }.call(this), _className(function () {
    try {
      var _ref;

      return [(_ref = {
        "k-component-copy": true
      }, _ref[className] = className, _ref)][0];
    } catch (e) {
      _e(e);
    }
  }.call(this)));
}